import fonts from '../fonts';
import { normalizeFontFamilyName } from '../normalize-font-family-name';
export const getFontFallback = (name) => {
    const normalizedName = normalizeFontFamilyName(name);
    const font = fonts.find(({ normalizedDisplayName, normalizedFontFamily }) => [normalizedFontFamily, normalizedDisplayName].includes(normalizedName));
    return font ? font.fallbacks : '';
};
//# sourceMappingURL=get-font-fallback.js.map